<template>
    <div>
      <h2>Gerenciar Bairros</h2>
      <form @submit.prevent="fetchGeoJson">
        <div>
          <label for="city">Cidade</label>
          <input type="text" v-model="city" required />
        </div>
        <div>
          <label for="neighborhood">Bairro</label>
          <input type="text" v-model="neighborhood" required />
        </div>
        <button type="submit">Buscar GeoJSON</button>
      </form>
      <div v-if="geojson">
        <l-map
          style="height: 500px; width: 100%;"
          :zoom="12"
          :center="[latitude, longitude]"
        >
          <l-tile-layer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          ></l-tile-layer>
          <l-geo-json :geojson="geojson"></l-geo-json>
        </l-map>
      </div>
    </div>
</template>
  
<script>
  import { LMap, LTileLayer, LGeoJson } from "vue2-leaflet";
  import "leaflet/dist/leaflet.css";
  
  export default {
    components: {
      LMap,
      LTileLayer,
      LGeoJson,
    },
    data() {
      return {
        city: "",
        neighborhood: "",
        geojson: null,
        latitude: -23.5505, // Coordenadas padrão (São Paulo)
        longitude: -46.6333, // Coordenadas padrão (São Paulo)
      };
    },
    methods: {
      async fetchGeoJson() {
        try {
          const response = await fetch(
            `/api/teste?city=${this.city}&neighborhood=${this.neighborhood}`
          );
          if (!response.ok) {
            throw new Error("GeoJSON not found");
          }
          const data = await response.json();
          this.geojson = data;
  
          // Atualizar as coordenadas do mapa para o centro do bairro (assumindo que o primeiro ponto é representativo)
          if (this.geojson.features.length > 0) {
            const firstFeature = this.geojson.features[0];
            if (firstFeature.geometry && firstFeature.geometry.coordinates.length > 0) {
              const firstCoordinate = firstFeature.geometry.coordinates[0][0];
              this.latitude = firstCoordinate[1];
              this.longitude = firstCoordinate[0];
            }
          }
        } catch (error) {
          console.error("Error fetching GeoJSON:", error);
        }
      },
    },
  };
</script>
  
<style>
  #map {
    height: 500px;
    width: 100%;
  }
</style>
  